<template>
	<div class="row my-4">
		<div class="col-sm-12 position-relative border border-warning">
			<div class="row mb-2">
				<h5 class="bg-info p-2">Customize Package</h5>
			</div>
			<div class="row">
				<div class="form-group col-sm-6">
					<BaseMultiSelect
						@update:value="setCountry"
						:options="multiSelectState.countriesSelect"
						rules="required"
						name="Country"
						mode="single"
						:required="true"
						:defaultData="data?.country?.id"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>
				<div class="form-group col-sm-6">
					<div class="row mt-4">
						<div class="col-sm-6 d-flex align-items-center mt-3">
							<BaseRadio
								class="form-check-input m-0"
								labelClass="small text-muted"
								label="Countries Only"
								id="Countries"
								name="Choice"
								v-model="data.choice"
							/>
						</div>
						<div class="col-sm-6 d-flex align-items-center mt-3">
							<BaseRadio
								class="form-check-input m-0"
								labelClass="small text-muted"
								label="Countries & Cities"
								id="CountriesCities"
								name="Choice"
								v-model="data.choice"
							/>
						</div>
					</div>
				</div>

				<div v-if="data.choice === 'Countries & Cities'" class="row my-4">
					<div
						v-for="(count, index) in componentCount.count"
						:key="`${count}-stay`"
						class="col-md-6"
					>
						<CityStay
							:id="count"
							:nameIndex="index"
							:country="data.country.name"
							:cityObj="data?.cityStay[index]?.city"
							:stayCount="data?.cityStay[index]?.stayNights"
							@removeComponent="removeComponent"
							@updateData="updateData"
						/>
					</div>
					<div class="">
						<a
							class="cursor-pointer btn btn-sm text-danger"
							@click.stop="addComponent"
							><i class="bi bi-plus-circle"></i> Add More</a
						>
					</div>
				</div>

				<div class="form-group col-sm-6 mb-6">
					<BaseMultiSelect
						@update:value="setServices"
						:options="multiSelectState.services"
						rules="required"
						:required="true"
						name="Services"
						:defaultData="data?.services"
						mode="tags"
						@inputError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>
				<div class="form-group col-sm-6 mb-6">
					<BaseMultiSelect
						@update:value="setStarRating"
						:options="multiSelectState.starRatings"
						rules="required"
						:required="true"
						:defaultData="data?.hotelRating"
						name="Hotel Rating (star)"
						mode="single"
						@inputError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>

				<div class="form-group col-sm-3">
					<BaseInput
						name="Travel Date"
						label="Travel Date"
						type="date"
						:min="`${new Date().toISOString().split('T')[0]}`"
						v-model="data.travelDate"
						class="form-control form-control-lg dashInput"
						rules="required"
						:required="true"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>
				<div class="form-group col-sm-3 mb-6">
					<BaseMultiSelect
						@update:value="setFlexibility"
						:options="multiSelectState.flexibility"
						rules="required"
						name="Flexibility"
						:defaultData="data?.flexibility"
						mode="single"
						@inputError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>

				<div class="form-group col-sm-3">
					<BaseInput
						name="No. of Rooms"
						label="No. of Rooms"
						type="number"
						:min="1"
						v-model="data.numberOfRooms"
						class="form-control form-control-lg dashInput"
						rules="required"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>
				<div class="form-group col-sm-3 mb-6">
					<BaseMultiSelect
						@update:value="setPreference"
						:options="multiSelectState?.preference"
						:defaultData="data.preference"
						rules="required"
						name="Preference"
						mode="single"
						@inputError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>
				<div class="form-group col-sm-4">
					<BaseInput
						name="Budget"
						label="Budget"
						type="number"
						:min="2000"
						v-model="data.budget"
						class="form-control form-control-lg dashInput"
						rules="required"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>
			</div>
			<div class="form-group col-sm-12 mb-2 small text-muted">
				<BaseTextArea
					v-model="data.description"
					name="Description"
					label="Description"
					rules="required|min:10"
					:required="true"
					@valError="inputError"
					@valSuccess="inputSuccess"
				/>
			</div>
		</div>
	</div>
</template>
<script>
	import { reactive, watch, inject, provide, onBeforeUnmount } from "vue";
	import Helper from "@/helpers/dataHelper";

	import BaseInput from "./BaseInput.vue";
	import BaseMultiSelect from "./BaseMultiSelect.vue";
	import BaseTextArea from "./BaseTextArea.vue";
	import BaseCheckBox from "./BaseCheckBox.vue";
	import BaseRadio from "./BaseRadio.vue";
	import CityStay from "./CityStay.vue";

	export default {
		name: "LeadCustomizePackage",
		components: {
			BaseInput,
			BaseMultiSelect,
			BaseTextArea,
			BaseCheckBox,
			BaseRadio,
			CityStay,
		},
		props: {
			count: { type: Number, default: 0 },
		},
		emits: ["updateData"],
		setup: (props) => {
			provide("data", data);
			const leadState = inject("leadState");
			const masterStore = inject("masterStore");

			const data = reactive({
				status: true,
				choice: "Countries Only",
				country: {
					id: 0,
					name: null,
				},
				cityStay: [],
				services: [],
				hotelRating: null,
				travelDate: null,
				flexibility: null,
				preference: null,
				numberOfRooms: 0,
				budget: 0,
				description: "",
			});

			watch(
				() => data,
				(preValue, newValue) => {
					if (
						data.country?.name &&
						data?.travelDate &&
						data?.description &&
						data?.services.length
					) {
						leadState.state.data.customizePackage = { ...data };
					}
				},
				{ deep: true },
			);

			watch(
				() => data.choice,
				(newValue, preValue) => {
					if (data.choice === "Countries Only") {
						data.cityStay = {};
					}
				},
			);

			const multiSelectState = reactive({
				countries: [],
				countriesSelect: [],
				cities: [],
				citiesSelect: [],
				states: [],
				statesSelect: [],
				preference: Helper.preferences,
				services: Helper.services,
				starRatings: Helper.rating,
				flexibility: Helper.flightFlexibility,
			});

			// ! Country Functions
			const getCountries = async () => {
				try {
					const response = await Helper.getCountries();
					const countries = response;
					multiSelectState.countries = countries;
					multiSelectState.countriesSelect = countries.map((country) => {
						return { label: country.name, value: country.id };
					});
				} catch (error) {
					console.log(error);
				}
			};
			getCountries();

			const setCountry = (dataObj) => {
				if (!dataObj) {
					data.country.id = 0;
					data.country.name = null;
					return;
				}
				// ? finding selected city data
				const country = multiSelectState.countries.filter(
					(country) => country.id === dataObj,
				);
				data.country.id = country[0].id;
				data.country.name = country[0].name;
			};

			const setEditorData = (payload) => {
				data.description = payload;
			};

			const setServices = (payload) => {
				data.services = payload;
			};

			const setStarRating = (payload) => {
				data.hotelRating = payload;
			};
			const setFlexibility = (payload) => {
				data.flexibility = payload;
			};
			const setPreference = (payload) => {
				data.preference = payload;
			};

			const componentCount = reactive({ count: [1] });
			// ? duplicating City Stay component
			const addComponent = () => {
				componentCount.count = [
					...componentCount.count,
					componentCount.count[componentCount.count.length - 1] + 1,
				];
			};
			const removeComponent = (id) => {
				if (data.cityStay.length)
					data.cityStay = data.cityStay.filter((city) => city.id !== id);
				const newCount = componentCount.count.filter((count) => count !== id);
				componentCount.count = newCount;
			};

			const updateData = (payload) => {
				if (Object.keys(data.cityStay).length) {
					let found = false;
					data.cityStay.map((city) => {
						if (city.id === payload.id && city.city.id === payload.city.id) {
							city.city.id = payload.city.id;
							city.city.name = payload.city.name;
							city.stayNights = payload.stayNights;
							found = true;
						}
					});

					if (!found) {
						data.cityStay = [...data.cityStay, payload];
					}
				} else {
					data.cityStay = [...data.cityStay, payload];
				}
			};

			if (masterStore.state.activeComponent === "edit") {
				// setting state for data editing
				let keys = Object.keys(data);
				let packageData = Object.create(leadState.state.data.customizePackage);
				keys.map((key) => {
					data[key] = packageData[key] || data[key];
				});

				if (leadState.state.data.customizePackage?.cityStay.length) {
					leadState.state.data.customizePackage?.cityStay.map((cityObj) => {
						multiSelectState.cities = [
							...multiSelectState.cities,
							{
								name: cityObj.city.name,
								id: cityObj.city.id,
							},
						];
						multiSelectState.citiesSelect = [
							...multiSelectState.citiesSelect,
							{
								label: cityObj.city.name,
								value: cityObj.city.id,
							},
						];
					});
				}
				if (leadState.state.data.customizePackage?.travelDate) {
					data.travelDate =
						leadState.state.data.customizePackage?.travelDate.split("T")[0];
				}
			}

			const inputError = (input) => {};
			const inputSuccess = (input) => {};

			onBeforeUnmount(
				() =>
					(leadState.state.data.customizePackage = {
						status: false,
					}),
			);

			return {
				data,
				multiSelectState,
				componentCount,

				setCountry,
				setEditorData,
				setServices,
				setStarRating,
				setFlexibility,
				setPreference,

				addComponent,
				removeComponent,
				updateData,

				inputError,
				inputSuccess,
			};
		},
	};
</script>
